<template>
  <div>
    <!-- 
    <el-row>
      <h3>
        Hola
      </h3>
    </el-row> 
    -->
    <RabbeyTable3
      @rtable-push-action="handlerOpcion"
      :data="items"
      :actions="IsPenging ? ActionPending : ActionTask"
      :columns="TaskColumns"
    />

    <TaskForm ref="taskForm" @update="update" :append-to-body="true">
    </TaskForm>
  </div>
</template>

<script>
import {
  TaskColumns,
  ActionTask,
  ActionPending
} from "../objetives/DashBoardColumns";
import RabbeyTable3 from "@/components/RabbeyTable3.vue";
import TaskForm from "../objetives/TaskForm.vue";

export default {
  name: "commonTask",
  components: {
    RabbeyTable3,
    TaskForm
  },
  props: {
    items: Array,
    IsPenging: Boolean,
    heigth: { type: Number, default: 700 },
    size: { type: Number, default: 20 }
  },
  data() {
    return {
      TaskColumns,
      ActionTask,
      ActionPending
    };
  },
  methods: {
    async update() {
      this.$emit("update");
    },
    async getObejetive(id) {
      const uri = `api/CMI/Objetives/getobjetiveByID?Id=${id}`;
      const response = await this.$http.get(uri);
      const { data } = response;
      return data;
    },
    async handlerOpcion(event) {
      const { row, command } = event;
      const Objetivo = await this.getObejetive(row.ObjetiveID);
      const data = {
        task: row,
        objective: {
          row: Objetivo
        }
      };

      if (command === "view-see-Approve") {
        this.AcceptedValue(row);
      } else {
        this.$refs.taskForm.show(data, false, false, true);
      }
    },
    AcceptedValue(row) {
      const { ResponsableId } = row;
      const { ID } = row;
      const RequesterId = this.currentUser.EmployeeId;
      this.$http
        .post(
          `/api/CMI/Task/canchangeTask?requesterId=${RequesterId}&ResponsableId=${ResponsableId}&TaskId=${ID}`
        )
        .then(({ data }) => {
          if (data) {
            this.SaveAfterAceptWhoCanChange(row);
          } else {
            this.$message({
              type: "info",
              message: "Usted no puede autorizar este cambio"
            });
          }
        });
    },
    SaveAfterAceptWhoCanChange(row) {
      const apiAllow = `/api/CMI/Task/allowPercentage`;
      this.$prompt(
        "Por favor digita un comentario de confirmación",
        "Message de confirmación",
        {
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              if (instance.inputValue) {
                this.$http
                  .post(apiAllow, {
                    comment: instance.inputValue,
                    taskid: row.ID
                  })
                  .then(() => {
                    this.$message({
                      type: "success",
                      message: "Registro actualizado correctamente"
                    });
                    this.getObejetive();
                    this.HandlerEvent();
                    done();
                  })
                  .catch((err) => {
                    this.$message({ type: "danger", message: err });
                  });
              } else {
                this.$message({
                  type: "danger",
                  message: "Debes de digitar un comentario valido"
                });
              }
            }
            if (action === "cancel") {
              done();
            }
          }
        }
      ).catch(() => {
        this.$message({
          type: "info",
          message: "Confirmacion cancelada"
        });
      });
    },
    async HandlerEvent() {
      let uri = "/api/CMI/Task/Enfoques/items";
      let params = {
        CompanyID: this.currentCompany,
        Employeeid: this.employee,
        option: this.lastOption
      };
      this.lastOption = params.option;
      const { data } = await this.$http.get(uri, { params });
      this.items = data;
    },
    getDataForReport() {
      this.loadingUI = true;

      this.$http
        .get(`/api/CMI/Objetives/ReportObjetiveByCompany`, {
          params: {
            CompanyID: this.currentCompany,
            DirecctionID: this.directionId,
            DepartmentID: this.deparment,
            ResponsableID: this.employeeId,
            Byme: this.Byme,
            DueDate: this.duedate,
            Date: this.date,
            Input: this.input
          }
        })
        .then((resp) => {
          this.reportData = resp.data;
          this.ExtractLabelsAndValues(resp.data);
          this.loadingUI = false;
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err.message
          });
        });
    }
  }
};
</script>

<style></style>
